import { render, staticRenderFns } from "./Seconbatch.vue?vue&type=template&id=b8fc3ac2&scoped=true&"
import script from "./Seconbatch.vue?vue&type=script&lang=js&"
export * from "./Seconbatch.vue?vue&type=script&lang=js&"
import style0 from "./Seconbatch.vue?vue&type=style&index=0&id=b8fc3ac2&scoped=true&lang=css&"
import style1 from "./Seconbatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc3ac2",
  null
  
)

export default component.exports